import { render, staticRenderFns } from "./layout-sent.vue?vue&type=template&id=760320b0&scoped=true"
import script from "./layout-sent.vue?vue&type=script&lang=js"
export * from "./layout-sent.vue?vue&type=script&lang=js"
import style0 from "./layout-sent.vue?vue&type=style&index=0&id=760320b0&prod&lang=scss&scoped=true"
import style1 from "./layout-sent.vue?vue&type=style&index=1&id=760320b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760320b0",
  null
  
)

export default component.exports